import React, {useEffect, useState} from 'react'
import SEO from '../components/SEO'
import HeaderV2 from './../components/HomePageV2/HeaderV2'
import HeroV2 from '../components/HomePageV2/HeroV2'
import TopBrokeragesV2 from '../components/HomePageV2/TopBrokeragesV2'
import FeaturesV2 from '../components/HomePageV2/FeaturesV2'
import WhyHomeLightV2 from '../components/HomePageV2/WhyHomeLightV2'
import PricingV2 from '../components/HomePageV2/PricingV2'
import TryItV2 from '../components/HomePageV2/TryItV2'
import FooterV2 from '../components/HomePageV2/FooterV2'
import ContactModalV2 from '../components/HomePageV2/ContactModalV2'
import DemoModalV2 from '../components/HomePageV2/DemoModalV2'
import SignupFormMob from '../components/SignupFormMob'
import listingManagementLogo from '../images/icons/listing-management-logo.svg'
import config from '../config/index'
import '../components/HomePageV2/styles.css'

function SignupModal() {
  const closeModal = () => {
    window.location.hash = ''
  }

  useEffect(() => {
    const syncBodyScroll = () => {
      document.body.style.overflow = window.location.hash === '#signup-mod' ? 'hidden' : ''
    }

    syncBodyScroll()
    window.addEventListener('hashchange', syncBodyScroll)

    return () => {
      window.removeEventListener('hashchange', syncBodyScroll)
      document.body.style.overflow = ''
    }
  }, [])

  return (
    <div className="modal hlm-signup-modal signup-mods" id="signup-mod">
      <a href="#" className="modal-overlay hlm-signup-modal-overlay" aria-label="Close" />
      <div className="modal-container hlm-signup-modal-card" role="dialog" aria-modal="true" aria-labelledby="signup-title">
        <div className="hlm-signup-modal-glow" aria-hidden="true" />
        <button type="button" className="hlm-signup-modal-close" aria-label="Close" onClick={closeModal}>
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
        <div className="hlm-signup-modal-content">
          <img className="hlm-signup-modal-logo" src={listingManagementLogo} alt="HomeLight Listing Management" />
          <h2
            id="signup-title"
            className="hlm-modal-title"
            style={{
              margin: 0,
              fontSize: 'clamp(26px, 4.4vw, 32px)',
              fontWeight: 800,
              letterSpacing: '-0.02em',
              lineHeight: 1.1,
              color: 'rgb(39, 54, 83)',
            }}>
            Getting started is <span className="hlm-modal-title-highlight">easy — and free.</span>
          </h2>
          <p className="hlm-modal-sub">Enter the email you would like to use as your main account login.</p>
          <div className="hlm-signup-modal-form-wrap">
            <label className="hlm-signup-modal-label" htmlFor="hlm-signup-email">
              WORK EMAIL
            </label>
            <SignupFormMob size="md" className="hlm-signup-modal-form" inputId="hlm-signup-email" />
          </div>
          <div className="hlm-signup-modal-trust" aria-label="Signup benefits">
            <span>
              <span className="hlm-signup-modal-check" aria-hidden="true">
                ✓
              </span>
              14-day free trial
            </span>
            <span>
              <span className="hlm-signup-modal-check" aria-hidden="true">
                ✓
              </span>
              No credit card
            </span>
            <span>
              <span className="hlm-signup-modal-check" aria-hidden="true">
                ✓
              </span>
              Cancel anytime
            </span>
          </div>
          <p className="hlm-signup-modal-signin-copy">
            Already have an account?{' '}
            <a href={`${config.appUrl}/auth/login`} target="_blank" rel="noreferrer">
              Log in here
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

function HomePageV2() {
  const [contactOpen, setContactOpen] = useState(false)
  const [demoOpen, setDemoOpen] = useState(false)

  return (
    <div className="hlm-page">
      <SEO
        title="HomeLight Listing Management - The simplest way to manage a listing."
        meta={[
          {
            name: 'description',
            content:
              'HomeLight Listing Management helps listing teams manage offers, disclosures, listing packages, and buyer interest reports — all in one secure place.',
          },
          {property: 'og:title', content: 'HomeLight Listing Management'},
          {
            property: 'og:description',
            content: 'The simplest way for real estate professionals to manage every active listing from sign to close.',
          },
          {property: 'og:type', content: 'website'},
        ]}
      />
      <HeaderV2 onContact={() => setContactOpen(true)} />
      <HeroV2 onDemo={() => setDemoOpen(true)} />
      <TopBrokeragesV2 />
      <FeaturesV2 />
      <WhyHomeLightV2 />
      <PricingV2 />
      <TryItV2 />
      <FooterV2 />
      <SignupModal />
      <DemoModalV2 open={demoOpen} onClose={() => setDemoOpen(false)} />
      <ContactModalV2 open={contactOpen} onClose={() => setContactOpen(false)} />
    </div>
  )
}

export default HomePageV2
